import { render } from "./EventBanner.vue?vue&type=template&id=6fc9a012&scoped=true"
import script from "./EventBanner.vue?vue&type=script&lang=js"
export * from "./EventBanner.vue?vue&type=script&lang=js"

import "./EventBanner.vue?vue&type=style&index=0&id=6fc9a012&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc9a012"]])

export default __exports__